import React, { useState, useEffect } from "react"
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import toast from "react-hot-toast"
import Navbar from "../../../Components/Navbar/Navbar"
import Table from "../../../Components/TableTemplate/DataTable"
import DeleteModal from "../../../Components/Modals/DeleteModal"
import CloseModal from "../../../Components/Modals/CloseModal"
import downloadIcon from "../../../Assets/Images/download_icon.png"

import {
  refreshPage,
  toastStyle,
  TokenExpiry,
  getType,
  numberFormat,
  selectDropdownStyle,
} from "../../../Helpers/Utils/Common"
import * as XLSX from "xlsx"
import Moment from "moment"
import Select from "react-select"
import {
  closeSalesQuotation,
  deleteSalesQuotation,
  getSalesQuotation,
} from "../../../Helpers/apiCalls/SalesModule/SalesQuotationApi"
import { getCustomer } from "../../../Helpers/apiCalls/Manage/CustomersApi"
import Footer from "../../../Components/Footer/Footer"
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination"
import SalesModal from "../Component/SalesModal"

export default function SalesQuotation() {
  let navigate = useNavigate()
  const userType = getType()
  const [inactive, setInactive] = useState(true)
  const [showLoader, setShowLoader] = useState(false)
  const [customers, setCustomers] = useState([])
  const [isClicked, setIsClicked] = useState(false)
  const [excelData, setExcelData] = useState([])
  const [tableData, setTableData] = useState([])
  const [selectedRow, setSelectedRow] = useState({})
  const [showSendModal, setShowSendModal] = useState(false)
  const handleShowSendModal = () => setShowSendModal(true)
  const handleCloseSendModal = () => setShowSendModal(false)
  // const [branch, setBranch] = useState({});
  const xlsxHeaders = [
    "QUOTATION DATE",
    "DLVRY DATE",
    "DOC. NO",
    "CUSTOMER",
    "BRANCH",
    "TOTAL",
    "STATUS",
  ]

  /* FILTER CONFIGS */
  const [filterConfig, setFilterConfig] = useState({
    franchise: "",
    tab: "pending",
    status: "pending",
    payment_status: "",
    franchised_on_from: "",
    franchised_on_to: "",
    page: 1,
  })
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }

  function handleFilterChange(e) {
    const { name, value } = e.target
    setFilterConfig((prev) => {
      return { ...prev, [name]: value }
    })
  }

  const handleTabSelect = (tabKey) => {
    setCurrentPage(1)
    setFilterConfig((prev) => {
      return {
        ...prev,
        tab: tabKey,
        status: tabKey,
        branch_id: "",
        customer_id: "",
        // customer_id_value: {
        //   label: "All Customers",
        //   value: "",
        // },
        date_from: "",
        date_to: "",
        page: 1,
      }
    })
  }

  async function fetchData() {
    setShowLoader(true)
    setTableData([])
    setExcelData([])
    setTotalItems(0)

    const response = await getSalesQuotation(filterConfig)
    if (response.data) {
      var sortedData = response.data.data.sort((a, b) =>
        a.branch_name > b.branch_name
          ? 1
          : b.branch_name > a.branch_name
          ? -1
          : 0
      )

      var allBills = sortedData.map((data) => {
        var info = data
        info.added_on =
          data.added_on !== "0000-00-00"
            ? Moment(data.added_on).format("MMM DD, YYYY")
            : "None"
        info.delivery_date =
          data.delivery_date !== "0000-00-00"
            ? Moment(data.delivery_date).format("MMM DD, YYYY")
            : "None"
        info.doc_no = data.id
        info.customer_name = data.customer_name
        info.branch_name = data.branch_name
        info.grand_total = numberFormat(info.grand_total)
        info.status = data.status
        return info
      })
      setTableData(allBills)

      var excel = allBills.map((bill) => {
        var info = {}
        info.added_on = bill.added_on
        info.delivery_date = bill.delivery_date
        info.doc_no = bill.doc_no
        info.customer_name = bill.customer_name
        info.branch_name = bill.branch_name
        info.grand_total = bill.grand_total
        info.status = bill.status
        return info
      })
      setExcelData(excel)
      setTotalItems(response.data.size)
    } else if (response.error) {
      TokenExpiry(response)
    }
    setShowLoader(false)
  }

  function handleExport() {
    const rows = excelData
    const worksheet = XLSX.utils.json_to_sheet(rows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1")
    XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" })
    XLSX.writeFile(workbook, "SalesQuotation.xlsx", { compression: true })
  }

  async function fetchCustomers() {
    setShowLoader(true)

    const response = await getCustomer({})

    if (response.error) {
      TokenExpiry(response.error)
    } else {
      var data = response.data.data.map((data) => {
        var info = data
        info.label = data.trade_name
        info.value = data.id
        info.var_name = "customer_id"
        return info
      })
      setCustomers([{ label: "All Customers", value: "" }, ...data])
    }
    setShowLoader(false)
  }

  /* add payment modal handler */
  // const [showAddPaymentModal, setShowAddPaymentModal] = useState(false);
  // const handleShowAddPaymentModal = () => setShowAddPaymentModal(true);
  // const handleCloseAddPaymentModal = () => setShowAddPaymentModal(false);

  /* add payment modal handler */
  // const [showConfirmPaymentModal, setShowConfirmPaymentModal] = useState(false);
  // const handleShowConfirmPaymentModal = () => setShowConfirmPaymentModal(true);
  // const handleCloseConfirmPaymentModal = () => setShowConfirmPaymentModal(false);

  /* delete modal handler */
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const handleShowDeleteModal = () => setShowDeleteModal(true)
  const handleCloseDeleteModal = () => setShowDeleteModal(false)

  /* close modal handler */
  const [showCloseQuoteModal, setShowCloseQuoteModal] = useState(false)
  const handleShowCloseQuoteModal = () => setShowCloseQuoteModal(true)
  const handleCloseCloseQuoteModal = () => setShowCloseQuoteModal(false)

  async function handleDeletePI() {
    setIsClicked(true)
    const response = await deleteSalesQuotation(selectedRow.id)

    if (response.data) {
      toast.success("Sales Quotation Deleted Successfully!", {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      toast.error("Error Deleting Sales Quotation", {
        style: toastStyle(),
      })
    }
  }

  async function handleClosePI() {
    setIsClicked(true)
    const response = await closeSalesQuotation(selectedRow.id)

    if (response.data) {
      toast.success("Sales Quotation Closed Successfully!", {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      toast.error("Error Closing Sales Quotation", {
        style: toastStyle(),
      })
    }
  }

  function handleSelectChange(e, row) {
    setSelectedRow(row)
    if (e.target.value === "edit") {
      navigate("edit/" + row.id)
    } else if (e.target.value === "print") {
      navigate("print/" + row.id)
    } else if (e.target.value === "email-quote") {
      handleShowSendModal()
    } else if (e.target.value === "delete") {
      handleShowDeleteModal()
    } else if (e.target.value === "close-quote") {
      handleShowCloseQuoteModal()
    }
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        onChange={(e) => handleSelectChange(e, row)}
      >
        <option value="" hidden selected>
          Select
        </option>
        <option value="print" className="color-options">
          View
        </option>
        {filterConfig.status === "pending" && (
          <>
            {/* <option value="email-quote" className="color-options">
              Email to Customer
            </option> */}
            <option value="close-quote" className="color-options">
              Close Quotation
            </option>
          </>
        )}
        {(userType === "admin" || userType === "wholesale_head") &&
          filterConfig.status === "pending" && (
            <option value="edit" className="color-options">
              Edit
            </option>
          )}
        {(userType === "admin" || userType === "wholesale_head") && (
          <option value="delete" className="color-red">
            Delete
          </option>
        )}
      </Form.Select>
    )
  }

  function CreateOrder(row) {
    return (
      <button
        type="button"
        className="btn btn-sm view-btn-table"
        onClick={(e) => handleCreateOrder(row.id)}
      >
        Create Order
      </button>
    )
  }

  function handleCreateOrder(id) {
    navigate("/salesorder/add/" + id)
  }

  function ViewBtn(row) {
    return (
      <button
        type="button"
        className="btn btn-sm view-btn-table"
        onClick={(e) => handleViewBtn(row.id)}
      >
        View
      </button>
    )
  }

  function handleViewBtn(id) {
    navigate("/salesquotation/print/" + id)
  }

  useEffect(() => {
    fetchCustomers()
  }, [])

  useEffect(() => {
    fetchData()
  }, [filterConfig, currentPage])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"WHOLESALE"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              SALES QUOTATION{" "}
            </h1>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              name="anything"
              placeholder="Search..."
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
              }
              className="search-bar"
            />
          </Col>
          <Col lg={2} className="mt-4 mt-lg-0">
            <div className="PO-filters">
              <button
                className="add-btn"
                onClick={() => navigate("/salesquotation/add")}
              >
                Add
              </button>
            </div>
          </Col>
        </Row>

        <Tabs activeKey={filterConfig.tab} onSelect={handleTabSelect}>
          <Tab eventKey="pending" title="pending" className="__table-container">
            <div className="">
              <div className="mb-3" />
              <span className=" mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
              </span>
              <Row className="PO-filters flex flex-row my-1">
                <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                  <Select
                    className="dropsearch-filter"
                    classNamePrefix="react-select"
                    placeholder="Select Customer"
                    styles={selectDropdownStyle}
                    value={filterConfig.customer_id_value}
                    options={customers}
                    onChange={(e) => {
                      setFilterConfig((prev) => {
                        return {
                          ...prev,
                          customer_id: e.value,
                          customer_id_value: {
                            label: e.label,
                            value: e.value,
                          },
                        }
                      })
                    }}
                  />
                </Col>
              </Row>
              <div className="mb-2" />

              <TableWithDynamicPagination
                tableHeaders={[
                  "/",
                  "QUOTATION DATE",
                  "DLVRY DATE",
                  "DOC. NO",
                  "CUSTOMER",
                  "BRANCH",
                  "TOTAL",
                  "STATUS",
                  "ACTIONS",
                ]}
                headerSelector={[
                  "/",
                  "added_on",
                  "delivery_date",
                  "id",
                  "customer_name",
                  "branch_name",
                  "grand_total",
                  "status",
                ]}
                tableData={tableData}
                DoneBtn={(row) => CreateOrder(row)}
                ActionBtn={(row) => ActionBtn(row, "open_bill")}
                showLoader={showLoader}
                withActionData={false}
                // used in dynamic pagination
                totalItems={totalItems}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
            <div className="mb-2" />
          </Tab>
          <Tab eventKey="ordered" title="Ordered" className="__table-container">
            <div className="">
              <div className="mb-3" />
              <span className=" mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
              </span>
              <Row className="PO-filters flex flex-row  my-1">
                <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                  <Select
                    className="dropsearch-filter"
                    classNamePrefix="react-select"
                    placeholder="Select Customer"
                    styles={selectDropdownStyle}
                    value={filterConfig.customer_id_value}
                    options={customers}
                    onChange={(e) => {
                      setFilterConfig((prev) => {
                        return {
                          ...prev,
                          customer_id: e.value,
                          customer_id_value: {
                            label: e.label,
                            value: e.value,
                          },
                        }
                      })
                    }}
                  />
                </Col>
              </Row>
              <div className="mb-2" />

              <TableWithDynamicPagination
                tableHeaders={[
                  "/",
                  "QUOTATION DATE",
                  "DLVRY DATE",
                  "DOC. NO",
                  "CUSTOMER",
                  "BRANCH",
                  "TOTAL",
                  "STATUS",
                  "ACTIONS",
                ]}
                headerSelector={[
                  "/",
                  "added_on",
                  "delivery_date",
                  "id",
                  "customer_name",
                  "branch_name",
                  "grand_total",
                  "status",
                ]}
                tableData={tableData}
                DoneBtn={(row) => ViewBtn(row)}
                ActionBtn={(row) => ActionBtn(row, "open_bill")}
                showLoader={showLoader}
                withActionData={false}
                // used in dynamic pagination
                totalItems={totalItems}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
            <div className="mb-2" />
          </Tab>
          <Tab eventKey="closed" title="Closed" className="__table-container">
            <div className="">
              <div className="mb-3" />
              <span className="mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
              </span>
              <Row className="PO-filters flex flex-row my-1">
                <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                  <Select
                    className="dropsearch-filter"
                    classNamePrefix="react-select"
                    placeholder="Select Customer"
                    styles={selectDropdownStyle}
                    value={filterConfig.customer_id_value}
                    options={customers}
                    onChange={(e) => {
                      setFilterConfig((prev) => {
                        return {
                          ...prev,
                          customer_id: e.value,
                          customer_id_value: {
                            label: e.label,
                            value: e.value,
                          },
                        }
                      })
                    }}
                  />
                </Col>
              </Row>
              <div className="mb-2" />

              <TableWithDynamicPagination
                tableHeaders={[
                  "/",
                  "QUOTATION DATE",
                  "DLVRY DATE",
                  "DOC. NO",
                  "CUSTOMER",
                  "BRANCH",
                  "TOTAL",
                  "STATUS",
                  "ACTIONS",
                ]}
                headerSelector={[
                  "/",
                  "added_on",
                  "delivery_date",
                  "id",
                  "customer_name",
                  "branch_name",
                  "grand_total",
                  "status",
                ]}
                tableData={tableData}
                DoneBtn={(row) => ViewBtn(row)}
                ActionBtn={(row) => ActionBtn(row, "open_bill")}
                showLoader={showLoader}
                withActionData={false}
                // used in dynamic pagination
                totalItems={totalItems}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
            <div className="mb-2" />
          </Tab>
        </Tabs>
        <div className="mb-3" />
        <br />
        <br />
        <Row>
          <Col lg={10} className="mt-3 mt-lg-0"></Col>
          <Col lg={2} className="mt-3 mt-lg-0">
            <div className="PO-filters">
              <button
                type="button"
                className="primary-btn"
                onClick={handleExport}
              >
                <span className="me-2">
                  <img width={20} height={20} src={downloadIcon} alt=""></img>
                </span>
                Download
              </button>
            </div>
          </Col>
        </Row>
        <div className="mb-3" />
        <br />
        <br />
      </div>
      <DeleteModal
        show={showDeleteModal}
        onHide={() => handleCloseDeleteModal()}
        text="Sales Quotation"
        onDelete={() => handleDeletePI()}
        isClicked={isClicked}
      />
      <CloseModal
        show={showCloseQuoteModal}
        onHide={() => handleCloseCloseQuoteModal()}
        text="Sales Quotation"
        onDelete={() => handleClosePI()}
        isClicked={isClicked}
      />
      {/* <AddPaymentModal
                id={PIID}
                balance={balance}
                franchiseeID={franchiseeID}
                show={showAddPaymentModal}
                onHide={handleCloseAddPaymentModal}
            />
            <ConfirmPaymentModal
                // id={PIID}
                // balance={balance}
                // franchiseeID={franchiseeID}
                show={showConfirmPaymentModal}
                onHide={handleCloseConfirmPaymentModal}
                handler={handleShowAddPaymentModal}
            /> */}
      <Footer />
      <SalesModal
        show={showSendModal}
        hide={handleCloseSendModal}
        message="Are you sure want to send this sales quotation to the customer?"
        // handler={() => handleSendEmail("printablediv")}
        isClicked={isClicked}
      />
    </div>
  )
}
